import styled from 'styled-components';
export const CourseGrid = styled.section`
  min-width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 320px));
  justify-content: center;
  gap: var(--space-xl);
  /* border: 2px solid red; */
  @media screen and (max-width: 700px) {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: var(--space-m);
  }
  @media screen and (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;
export const NoCoursesFound = styled.p`
  grid-column: 1 / -1;
  margin: 0;
  padding: var(--space-xxl) 0;
  text-align: center;
  color: var(--grey4);
  font-weight: 700;
`;
